import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Link } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { TENANTS_WITH_MARKETPLACE_FUNCTIONALITY } from '../../../marketplace'
import { useSellerModalContext } from '../../../seller'

import { useProductSearchResultItemContext } from './ProductSearchResultItemContext/productSearchResultItemContext'

export const ProductSearchResultItemMarketplaceSeller: FC = () => {
  const {
    algoliaRecord: { best_offer, offers_count, upid },
  } = useProductSearchResultItemContext()

  const globalConfig = useGlobalConfigContext()

  const { showSellerModal } = useSellerModalContext()

  const isMarketplaceEnabled = TENANTS_WITH_MARKETPLACE_FUNCTIONALITY.has(
    globalConfig.tenant,
  )

  if (
    !isMarketplaceEnabled ||
    offers_count !== 1 ||
    !best_offer?.seller ||
    best_offer.type !== 'MIRAKL'
  ) {
    return null
  }

  const sellerId = best_offer.seller.id

  return (
    <div className="z-10 rounded-s bg-light-primary-medium p-3 text-xs font-medium">
      <FormattedMessage id="message.soldAndShipped.partner" />{' '}
      <Link
        data-clientside-hook={`open-seller-modal--${sellerId}`}
        data-qa-id="seller-name"
        onClick={() => {
          showSellerModal({
            productUpid: upid,
            sellerId,
          })
        }}
        slots={{ root: 'button' }}
        type="button"
      >
        {best_offer.seller.name}
      </Link>
    </div>
  )
}
